import React, { Suspense } from 'react';
import { Container } from '@mui/material';
import Box from '@components/Atoms/Box';
import ShowIf from '@components/Atoms/ShowIf';
import { useIsTeacher } from '@reducers/user/hooks';
import TeacherTestletView from './TeacherTestletView';
import { ConfirmationDialogProvider } from '../../contexts/ConfirmationDialogProvider';
import useSessionNotification from '../../hooks/sessionNotification';
import { SessionManagementProvider } from '../../contexts/SessionManagementProvider/SessionManagementProvider';
import useTestletSessionActivityNotification from '../../hooks/testletSessionAcitvityNotification';
import StudentTestletView from './StudentTestletView';

const TestletView: React.FC = () => {
  const isTeacher = useIsTeacher();
  useSessionNotification();
  useTestletSessionActivityNotification();

  return (
    <SessionManagementProvider>
      <ConfirmationDialogProvider>
        <Container maxWidth="xl" sx={{ m: '0 1.5rem', width: 'calc(100% - 3rem)' }}>
          <Suspense fallback={<div>Loading...</div>}>
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, mt: 4, height: '90vh' }}>
              <ShowIf If={isTeacher}>
                <TeacherTestletView />
              </ShowIf>
              <ShowIf If={!isTeacher}>
                <StudentTestletView />
              </ShowIf>
            </Box>
          </Suspense>
        </Container>
      </ConfirmationDialogProvider>
    </SessionManagementProvider>
  );
};

export default TestletView;
